import * as React from 'react';
export var useScrollControl = function (elem) {
    var _a = React.useState(true), isScrollTop = _a[0], setIsScrollTop = _a[1];
    var _b = React.useState(true), isScrollBottom = _b[0], setIsScrollBottom = _b[1];
    var onScroll = React.useCallback(function () {
        var _a, _b, _c;
        if (elem) {
            var scrollTop = ((_a = elem.current) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0;
            var scrollHeight = ((_b = elem.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) || 0;
            var clientHeight = ((_c = elem.current) === null || _c === void 0 ? void 0 : _c.clientHeight) || 0;
            var isBottom = scrollHeight - scrollTop === clientHeight;
            if (scrollTop > 0 && isScrollTop) {
                setIsScrollTop(false);
            }
            else if (scrollTop === 0 && !isScrollTop) {
                setIsScrollTop(true);
            }
            if (!isBottom && isScrollBottom) {
                setIsScrollBottom(false);
            }
            else if (isBottom && !isScrollBottom) {
                setIsScrollBottom(true);
            }
        }
    }, [elem, isScrollTop, isScrollBottom]);
    return {
        isScrollTop: isScrollTop,
        isScrollBottom: isScrollBottom,
        onScroll: onScroll,
    };
};
//# sourceMappingURL=index.js.map